import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function RequestToRefundBubble({
  chatMessage,
  history
}: PaymentBubbleCommonProps) {
  const totalAmount = (chatMessage?.rfq?.purchaseAmount ?? 0).toLocaleString(
    'ko'
  );
  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble error>
      <PaymentBubble.Title>환불 요청 후 대기중입니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={2} />
      <PaymentBubble.Content>
        파트너가 환불요청 승인 시 결제 대금은 자동 환불됩니다. 환불 관련 상담은
        파트너와 채팅을 통해 진행해주세요.
      </PaymentBubble.Content>
      <PaymentBubble.Content>
        총 환불금액 : {totalAmount}원
      </PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
